import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'

const noop = () => {}
const NavigationHistoryContext = createContext({
  addToHistory: noop,
  getPreviousLocation: () => null
})

export const NavigationHistoryProvider = ({ children }) => {
  const [history, setHistory] = useState([])

  const addToHistory = useCallback((location) => {
    setHistory((prev) => {
      const last = prev[prev.length - 1]
      if (
        last &&
        last.pathname === location.pathname &&
        (last.search || '') === (location.search || '') &&
        (last.hash || '') === (location.hash || '')
      ) {
        return prev
      }
      return [...prev, location]
    })
  }, [])

  const getPreviousLocation = useCallback(() => {
    if (history.length >= 2) {
      return history[history.length - 2]
    }
    if (history.length === 1) {
      return history[0]
    }
    return null
  }, [history])

  const value = useMemo(
    () => ({
      addToHistory,
      getPreviousLocation
    }),
    [addToHistory, getPreviousLocation]
  )

  return (
    <NavigationHistoryContext.Provider value={value}>
      {children}
    </NavigationHistoryContext.Provider>
  )
}

export const useNavigationHistory = () => {
  const context = useContext(NavigationHistoryContext)
  if (!context) {
    throw new Error('useNavigationHistory must be used within NavigationHistoryProvider')
  }
  return context
}
